module.exports = __webpack_public_path__ + "img/icon49.659f4762.png";